export default __webpack_public_path__ + "static/media/CloseCircle Red.a51953a2.svg";